/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Live pool figures for the occurrence just entered, as the escrow reports them. Not the board's configured prize pool.
 * @export
 * @interface LeaderboardJoinPrizePoolStatus
 */
export interface LeaderboardJoinPrizePoolStatus {
    /**
     * 
     * @type {string}
     * @memberof LeaderboardJoinPrizePoolStatus
     */
    leaderboardId?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardJoinPrizePoolStatus
     */
    currentPool?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardJoinPrizePoolStatus
     */
    entryCount?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardJoinPrizePoolStatus
     */
    entryFee?: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardJoinPrizePoolStatus
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardJoinPrizePoolStatus
     */
    platformFeePercent?: number;
}

/**
 * Check if a given object implements the LeaderboardJoinPrizePoolStatus interface.
 */
export function instanceOfLeaderboardJoinPrizePoolStatus(value: object): value is LeaderboardJoinPrizePoolStatus {
    return true;
}

export function LeaderboardJoinPrizePoolStatusFromJSON(json: any): LeaderboardJoinPrizePoolStatus {
    return LeaderboardJoinPrizePoolStatusFromJSONTyped(json, false);
}

export function LeaderboardJoinPrizePoolStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardJoinPrizePoolStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'leaderboardId': json['leaderboardId'] == null ? undefined : json['leaderboardId'],
        'currentPool': json['currentPool'] == null ? undefined : json['currentPool'],
        'entryCount': json['entryCount'] == null ? undefined : json['entryCount'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'platformFeePercent': json['platformFeePercent'] == null ? undefined : json['platformFeePercent'],
    };
}

export function LeaderboardJoinPrizePoolStatusToJSON(json: any): LeaderboardJoinPrizePoolStatus {
    return LeaderboardJoinPrizePoolStatusToJSONTyped(json, false);
}

export function LeaderboardJoinPrizePoolStatusToJSONTyped(value?: LeaderboardJoinPrizePoolStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leaderboardId': value['leaderboardId'],
        'currentPool': value['currentPool'],
        'entryCount': value['entryCount'],
        'entryFee': value['entryFee'],
        'currency': value['currency'],
        'platformFeePercent': value['platformFeePercent'],
    };
}

